"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var models_1 = require("./models");
var Accessor_1 = require("./models/Accessor");
var DataTable_1 = require("./models/DataTable");
// DateRange is fully inclusive, but in the case of relativeDateRanges, we want
// to apply an (exclusive, inclusive] range, so we adjust dateRange.first by
// the smallest unit available
exports.rangeRelativeToDate = function (date, relativeWindow) {
    var unitForMoment = exports.momentStringFromDateTrunc(relativeWindow.unit);
    var first = adjustDateForwardByOneMillisecond(exports.dateBefore(date, relativeWindow.numberOfUnits, unitForMoment));
    return { first: first, last: date };
};
var adjustDateForwardByOneMillisecond = function (date) { return moment(date).add(1, 'ms').toDate(); };
exports.dateBefore = function (date, amount, unit) {
    return moment(date).subtract(amount, unit).toDate();
};
exports.dateAfter = function (date, amount, unit) {
    return moment(date).add(amount, unit).toDate();
};
exports.withinRange = function (range, date) { return date >= range.first && date <= range.last; };
exports.momentStringFromDateTrunc = function (dateTrunc) {
    switch (dateTrunc) {
        case models_1.DateTrunc.SECOND: {
            return 'seconds';
        }
        case models_1.DateTrunc.MINUTE: {
            return 'minutes';
        }
        case models_1.DateTrunc.HOUR: {
            return 'hours';
        }
        case models_1.DateTrunc.ISO_WEEKDAY:
        case models_1.DateTrunc.DAY: {
            return 'days';
        }
        case models_1.DateTrunc.MONTH: {
            return 'months';
        }
        case models_1.DateTrunc.ISO_WEEK:
        case models_1.DateTrunc.WEEK: {
            return 'weeks';
        }
        case models_1.DateTrunc.ISO_QTR:
        case models_1.DateTrunc.QUARTER: {
            return 'quarters';
        }
        case models_1.DateTrunc.ISO_YEAR:
        case models_1.DateTrunc.YEAR: {
            return 'years';
        }
        default: {
            // compare to previous point
            return undefined;
        }
    }
};
exports.getDateRange = function (table, accessor) {
    if (accessor === void 0) { accessor = Accessor_1.DefaultTimestampAccessor; }
    if (table.length === 0) {
        return undefined;
    }
    var firstPoint = table[0];
    var lastPoint = table[table.length - 1];
    var first = accessor(firstPoint);
    var last = accessor(lastPoint);
    if (DataTable_1.isNullOrUndefined(first) || DataTable_1.isNullOrUndefined(last)) {
        return undefined;
    }
    return { first: first, last: last };
};
//# sourceMappingURL=dateUtils.js.map